import CampaignWhitelabelModal from '@/components/campaigns/modal/CampaignWhitelabel.vue'

/**
 * PD-4861 — entry point for campaign creation. Only asks which whitelabel when the
 * account can actually access more than one; otherwise it behaves exactly as the
 * plain link it replaced.
 *
 * PD-4877 — moved out of CampaignsIndex so the empty-state button reaches it too.
 *
 * SRR-2591 — split out of the Campaign mixin into its own file so any call site (the
 * dashboard hero button included) can pull in just this method instead of copying its
 * body. A second, drifted copy of the "push to campaign-new" path is what produced
 * both bugs this ticket references — the empty-state button, then the hero button.
 */
export default {
  methods: {
    startNewCampaign() {
      const apps = this.$store.getters['user/apps_list'] || []

      if (apps.length <= 1) {
        this.$router.push({ name: 'campaign-new' })

        return
      }

      this.$Modal.init(
        {
          propsData: {
            component: CampaignWhitelabelModal,
            meta: { title: this.$t('campaign.index.new_campaign'), apps },
            size: '480px',
          },
        },
        this
      )
    },
  },
}
